export interface CreateLpoCheckoutInput {
  offerId: string;
  quantity: number;
  locale: string;
  parentSlug: string;
  prefix?: string;
  webView?: boolean;
  mpid?: string | null;
}

export interface LpoReceipt {
  offerName: string;
  quantity: number;
  amountTotal: number;
  currency: string;
  reference: string;
  paymentStatus: string;
}

export class LpoCheckoutError extends Error {
  readonly status: number;
  constructor(status: number) {
    super('LPO checkout request failed');
    this.name = 'LpoCheckoutError';
    this.status = status;
  }
}

export const createLpoCheckout = async (
  input: CreateLpoCheckoutInput,
): Promise<{ url: string }> => {
  const response = await fetch('/api/lpo-checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(input),
  });
  if (!response.ok) throw new LpoCheckoutError(response.status);
  return response.json();
};

export const verifyLpoCheckout = async (
  sessionId: string,
): Promise<LpoReceipt> => {
  const response = await fetch(
    `/api/lpo-checkout/verify?session_id=${encodeURIComponent(sessionId)}`,
  );
  if (!response.ok) throw new LpoCheckoutError(response.status);
  return response.json();
};
